export default __webpack_public_path__ + "static/double-logo-sowos-06ec239770c285972390a251c8588c67.svg";